// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"516":"1a5a2b6d","709":"5259f60e","731":"2e9dc9bd","905":"bd378275"}[chunkId] + ".chunk.js";
};